// extracted by mini-css-extract-plugin
module.exports = {"grid":"bonus-grid_grid__2GYQz"};